import { render, staticRenderFns } from "./BatchInitNeCfgTable.vue?vue&type=template&id=b6d5770a&"
import script from "./BatchInitNeCfgTable.vue?vue&type=script&lang=js&"
export * from "./BatchInitNeCfgTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports